const ROUTES = {
  HEALTH: '/utils/health',

  // CONFIG: '/config',  TODO: deprecated remove
  OPTIONS: '/config/options',
  TRANSLATES: '/config/translates/{language}',

  ROLES: '/roles',
  ROLES_PERMISSIONS: '/roles/permissions',

  VERIFY_CODE: '/auth/verify/{verificationCode}',
  AUTH_GET_CLEARME: '/users/auth/clearme',
  AUTH_CLEARME_VERIFY: '/users/auth/clearme/verify',
  AUTH_REFRESH: '/auth/refresh',
  AUTH_LOGIN: '/auth/login',
  AUTH_LOGOUT: '/auth/logout',

  USER_SET_CURRENT_ROLE: '/auth/role/{role}',
  USER_INVITES: '/shared-users/jobs?filter=WITH_INVITATION',
  USER_REGISTER: '/auth/register',
  USER_RESEND: '/auth/resend',
  USERS_DIRECTORY: '/admin-users',
  USERS_UPLOAD: '/users/upload/{uuid}',
  USERS_DELETE_UPLOAD: '/users/upload/{id}',
  USERS_FAVORITE: '/users/favorites',
  USERS_BULK_UPLOAD: '/users/bulk-upload',
  NOTIFY_USERS: '/shared-users/workers/notify',
  LOAD_LINEMEN: '/users/workers/{eventId}',
  LOAD_TENANT_WORKERS: '/shared-users/workers/{eventId}',
  LOAD_TENANT_SUPPORTERS: '/users/supporters',
  LOAD_INVITED_LINEMEN_BY_LOCATION: '/shared-users/workers/{eventId}?invited=true',
  LOAD_POSSIBLE_ROSTER_OWNERS: '/{eventId}/rosters/owners',
  RESET_USER_PASSWORD: '/auth/reset',
  SET_USER_PASSWORD: '/auth/set-password',
  VERIFY_PASSWORD_TOKEN: '/auth/reset/{resetPasswordToken}',
  USER_UPDATE_PASSWORD: 'auth/change',

  EVENTS: '/events',
  FILTERED_EVENTS: '/shared-users/jobs?filter={filter}',
  EVENT: '/events/{id}',
  EVENT_WITH_FILTERS: '/events/{id}?{query}',
  EVENT_INVITATION_STATUS: '/events/{id}/invitations',
  EVENT_STATUS: '/events/{id}/status',

  ROSTERS: '/rosters',
  ROSTER: '/rosters/{id}',
  ROSTER_WITH_VERSION: '/rosters/{id}?version={version}&view=myCrew,myEqpt',
  ROSTER_AVAILABLE_VEHICLES: '/vehicles',
  ROSTER_EQUIPMENTS: '/rosters/{id}/equipments',
  ROSTER_ASSIGNMENTS: '/rosters/{id}/assignments',
  ROSTER_EQUIPMENT_SET_OPTIONS: '/rosters/{id}/equipments/{uuid}',
  ROSTER_LINEMAN_SET_OPTIONS: '/rosters/{id}/lineman/{uuid}', // TODO: old code. remove with connected implementation
  ROSTER_SET_STATUS: '/rosters/{id}/status',
  ROSTER_TIMESHEET: '/rosters/{id}/timesheet',
  ROSTER_TRANSFER: '/rosters/{id}/transfer',
  ROSTER_REVERT: '/rosters/{id}/revert',
  ROSTER_SPLIT: '/rosters/{id}/split',

  VEHICLES: '/vehicles',
  VEHICLE: '/vehicles/{id}',

  TENANTS: '/tenants',
  TENANT: '/tenants/{id}',
  TENANT_USERS_LIST: '/tenants/{tenantId}/users',
  TENANT_ADMINS: '/tenants/{id}/admins',
  TENANT_ADMIN: '/tenants/{tenantId}/admins/{uuid}',
  TENANT_ADMINS_INVITE: '/tenants/{id}/admins/invite',
  TENANT_ADMINS_INVITE_RESEND: '/tenants/{id}/admins/invite/resend/{uuid}',
  TENANT_ADMIN_REGISTRATION: '/tenants/{tenantId}/admins/registration/{code}',
  TENANT_USERS_INVITE: '/tenants/{id}/users/invite',
  TENANT_USERS_INVITE_RESEND: '/tenants/{id}/users/invite/resend/{uuid}',
  TENANT_USERS_PENDING: '/tenants/{id}/users/pending',
  TENANT_USERS_PENDING_DELETE: '/tenants/{id}/users/delete/{uuid}',
  TENANTS_FOR_SHARED_USER: '/tenants/my',
  TENANT_ACCEPT_INVITE: '/tenants/{id}/accept',
  TENANT_LOGO: '/tenants/{id}/logo',

  AVAILABLE_SHARED_USERS: '/shared-users/',
  SHARED_USERS_INVITE: '/shared-users/{id}/invite',
  SHARED_USERS_STATUS: '/admin-users/{tenantId}/{uuid}/status',

  STORM360_USERS: '/admin-users?registered={registered}',
  STORM360_ADMINS: '/admin-users/admins',
  STORM360_ADMIN_INVITE: '/admin-users/admins/invite',
  RESEND_STORM360_ADMIN_INVITE: '/admin-users/admins/invite/resend/{uuid}',
  STORM360_PENDING_ADMINS: '/admin-users/admins/pending',
  STORM360_PENDING_ADMINS_DELETE: '/admin-users/admins/pending/{uuid}',
  USER_ROLES: '/admin-users/{uuid}/roles',
  USERS: '/users',
  TENANT_USERS: '/users/tenants',
  TENANT_USERS_AUTH: '/auth/{code}',
  TENANT_USER: '/auth/me',
  TENANT_USER_PERMISSIONS: '/auth/permissions',
  TENANT_USERS_STATUS: '/admin-users/{uuid}/status',
  USERS_PROFILE: '/users/profile/',
  USER_UUID: '/users/{uuid}/profile',
  TENANT_USER_VERIFY_UNION: '/users/{uuid}/union-classification',
  USER_SETTINGS: '/users/settings',

  // TODO: should be removed in the future
  UTILITY_CLASSIFICATIONS: '/utility/{id}/classifications',

  // YARDS
  YARDS: '/yards',
  YARD: '/yards/{id}',
};

export default ROUTES;
